<template>
  <footer id="progress" class="active">
    <div class="footer-wrapper">
      <div class="icon icon-home" @click="onRestart"></div>
      <div class="progress-bar">
          <div class="bar">
            <div class="bar-inner" :style="style"></div>
          </div>
      </div>
      <div class="icon icon-complete"></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'ToolFooter',
  props: {
    progress: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      style: '',
    }
  },
  watch: {
    progress(value) {
      const percentage = Math.min(value * 100, 100);
      this.style = `width:${percentage}%;`;
    },
  },
  methods: {
    onRestart() {
      this.$emit('action', { type: 'home' });
    },
  },
}
</script>
